import { useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { Box } from '@gemini/core';
import { ArrowDownIcon, ArrowUpIcon } from '@gemini/icons';
import { Button } from '@gemini/ui';
import { NAME_SPACE } from '@mfe-presentation/hooks/useLoadTranslations';
import { useEffect, useState } from 'react';

const getAdditionnalServiceElementTop = (position = 'next') => {
    const elements = document.getElementsByClassName('estimation-result-block');
    let element = elements[elements.length - 1];
    let elementTop;
    if (element) {
        const topBarHeight = 48;
        elementTop = Math.floor(
            element.getBoundingClientRect().top + window.scrollY - topBarHeight,
        );
        if (position !== 'last') {
            for (const el of Array.from(elements)) {
                element = el;
                elementTop = Math.floor(
                    element.getBoundingClientRect().top + window.scrollY - topBarHeight,
                );
                if (window.scrollY < elementTop) {
                    break;
                }
            }
        }
    }
    return elementTop;
};

const EstimationResultFloatingButton = () => {
    const [displayFloatingButton, setDisplayFloatingButton] = useState(false);
    const [displayBackToTop, setDisplayBackToTop] = useState(false);
    const { t } = useTranslation(NAME_SPACE);

    useEffect(() => {
        setDisplayFloatingButton(document.body.offsetHeight > 1100);
    }, [document.body.offsetHeight]);

    useEffect(() => {
        const handleScroll = () => {
            const reachedLastAdditionnalService =
                window.scrollY >= (getAdditionnalServiceElementTop('last') || 0);
            const isAtBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight;

            const reached = reachedLastAdditionnalService || isAtBottom;
            setDisplayBackToTop(reached);
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleButtonClick = () => {
        const elementTop = getAdditionnalServiceElementTop();

        window.scrollTo({
            top: displayBackToTop ? 0 : elementTop,
            behavior: 'smooth',
        });
    };

    if (!displayFloatingButton) {
        return null;
    }

    return (
        <Box
            position="fixed"
            bottom={{
                'breakpoint.base': 'spacing.16',
                'breakpoint.sm': 'spacing.32',
            }}
            right={{
                'breakpoint.base': 'spacing.16',
                'breakpoint.sm': 'spacing.32',
            }}
            zIndex="zIndex.1"
        >
            <Button
                icon={displayBackToTop ? ArrowUpIcon : ArrowDownIcon}
                // @ts-expect-error transition is not in the props
                transitionDuration="motionDuration.200"
                transitionTimingFunction="motionEasing.ease-out"
                transitionProperty="width"
                iconPosition="end"
                iconOnly={displayBackToTop}
                variant={displayBackToTop ? 'primary-floating' : 'secondary-floating'}
                width={displayBackToTop ? '48px' : '180px'}
                onPress={handleButtonClick}
            >
                {displayBackToTop ? '' : t(`step_results.resultCard.button.discoverMore`)}
            </Button>
        </Box>
    );
};

export default EstimationResultFloatingButton;
